import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts'
import { SERVICE_PALETTE } from '../lib/colours'
import { useServiceBreakdown } from '../hooks/useServiceBreakdown'
import { getServiceAbbreviation } from '../lib/serviceAbbreviations'
import { EmptyState } from './EmptyState'

interface ServiceData {
  service: string
  cost: number
  percentage: number
}

interface CostByServicePieProps {
  data: ServiceData[]
}

export function CostByServicePie({ data }: CostByServicePieProps) {
  const { top10 } = useServiceBreakdown(data)

  if (!data || data.length === 0 || top10.length === 0) {
    return (
      <EmptyState
        icon="chart"
        title="No service cost data available"
        description="Service cost breakdown will appear here once data is available."
        className="h-80"
      />
    )
  }

  return (
    <ResponsiveContainer width="100%" height={350}>
      <PieChart>
        <Pie
          data={top10}
          dataKey="cost"
          nameKey="service"
          cx="50%"
          cy="50%"
          outerRadius={120}
          innerRadius={65}
          paddingAngle={1}
          label={({ name, percent }) =>
            `${getServiceAbbreviation(name)} ${Math.round(percent * 100)}%`
          }
        >
          {top10.map((entry, idx) => (
            <Cell key={entry.service} fill={SERVICE_PALETTE[idx % SERVICE_PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(v) =>
            `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          }
        />
      </PieChart>
    </ResponsiveContainer>
  )
}
